import {TargetSystemModel} from '../../target/target-system.model';
import {DistributionAccountModel} from '../distribution-account.model';

export class DistributionAccountListViewModel {
  targetSystemName: string;
  targetSystemId: number;

  id: number;
  partnerId: number;
  partnerName: string;
  foreignAccountId: string;
  description: string;
  visibleForAll: boolean;

  constructor(public targetSystem: TargetSystemModel,
              public distributionAccount: DistributionAccountModel,
              public partnerNames: { [key: number]: string; }) {
    this.targetSystemId = targetSystem.id;
    this.targetSystemName = targetSystem.name;
    this.id = distributionAccount.id;
    this.partnerId = distributionAccount.partnerId;
    this.foreignAccountId = distributionAccount.foreignAccountId;
    this.description = distributionAccount.description;
    this.partnerName = partnerNames[this.partnerId] || ('ID: ' + this.partnerId);
    this.visibleForAll = distributionAccount.visibleForAll;
  }
}
